import React from 'react'
import { Pressable, Text } from 'react-native'
import { useThemeValue } from '../../ThemeContext'
import { baseFont } from '../../utils/ui'

export function GhostButton({ label, onPress }: { label: string; onPress: () => void }) {
  const { theme } = useThemeValue()

  return (
    <Pressable
      onPress={onPress}
      style={{
        paddingHorizontal: 18,
        paddingVertical: 14,
        borderRadius: 16,
        backgroundColor: theme.colors.surface,
        borderWidth: 1,
        borderColor: theme.colors.border,
      }}
    >
      <Text
        style={{
          ...baseFont('700'),
          color: theme.colors.text,
          fontSize: 13,
          letterSpacing: 0.6,
          textTransform: 'uppercase',
          textAlign: 'center',
        }}
      >
        {label}
      </Text>
    </Pressable>
  )
}
